import cn from 'classnames'
import { type ReactElement } from 'react'
import { usdFormatter } from '../../../../../../shared/utils/formattingUtils'
import { type Transaction } from '../../../../../../shared/proxies/transactionsProxy'
import { TransactionType } from '../../../../../../shared/types/GlobalTranactionTypeEnum'
import {
  determineTransactionColorClass
} from '../../../../index/RecentSalesActivitySection/RecentActivitySubSection/utils'
import { determineTextColorClass } from './utils'

interface AmountCellProps {
  transaction: Transaction
}

export function AmountCell ({ transaction }: AmountCellProps): ReactElement {
  return (
    <div
      className={cn('p-4 font-semibold ', determineTransactionColorClass(transaction))}
    >
      {transaction.ppSslTransactionType === TransactionType.Return ? `(${usdFormatter.format(transaction.amountCents)})` : usdFormatter.format(transaction.amountCents)}
    </div>
  )
}

export function CondensedAmountCell ({ transaction }: AmountCellProps): ReactElement {
  return (
    <div
      className={
        cn(
          'font-semibold',
          determineTextColorClass(transaction)
        )
      }
    >
      {transaction.ppSslTransactionType === TransactionType.Return ? `(${usdFormatter.format(transaction.amountCents)})` : usdFormatter.format(transaction.amountCents)}
    </div>
  )
}
